import { useMemo } from 'react';

import { usePromoTrophyConnected } from '../../components/promotionsV2/helper/hooks/usePromoTrophyConnected';
import { useBetSlice } from '../../store/slices/bets/selectors';
import { ChipTypes } from '../../store/slices/chips/types';
import type { Trophy } from '../../store/slices/promotionsV2/types';

export const useTrophy = (hideTrophyTooltip?: boolean): Trophy => {
  const trophy = usePromoTrophyConnected();
  const isFreeBetPlaced = useBetSlice.getPlacedBetType() === ChipTypes.FreeChip;

  return useMemo(() => {
    if (hideTrophyTooltip) {
      trophy.toolTipContent = '';
    }

    if (isFreeBetPlaced) {
      return { ...trophy, enable: false };
    }

    return trophy;
  }, [isFreeBetPlaced, trophy]);
};
